import { render } from "./EmploymentStatus.vue?vue&type=template&id=ce31a1b6"
import script from "./EmploymentStatus.vue?vue&type=script&lang=js"
export * from "./EmploymentStatus.vue?vue&type=script&lang=js"

import exportComponent from "/Users/oscarbout/Code/3birdhrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__